import axios from 'axios';

const LOG_PATH = '/__flexboard_api_log__';

function shouldLogToTerminal() {
  return (
    process.env.NODE_ENV === 'development' &&
    process.env.REACT_APP_DEBUG_API === 'true'
  );
}

function sendLine(line) {
  if (typeof fetch === 'undefined') return;
  void fetch(LOG_PATH, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ line }),
    keepalive: true,
  }).catch(() => {});
}

function fullUrl(config) {
  try {
    return axios.getUri(config);
  } catch {
    const base = config.baseURL || '';
    const path = config.url || '';
    if (path.startsWith('http')) return path;
    const b = base.endsWith('/') ? base.slice(0, -1) : base;
    const p = path.startsWith('/') ? path : `/${path}`;
    return `${b}${p}`;
  }
}

/**
 * In development, log each completed HTTP call to the webpack dev-server terminal
 * (set REACT_APP_DEBUG_API=true in config/development/defaults.env.example). Filter by "[FlexBoard API]".
 */
export function attachApiTerminalLogging(client) {
  if (!shouldLogToTerminal()) return;

  client.interceptors.request.use((config) => {
    const start =
      typeof performance !== 'undefined' ? performance.now() : Date.now();
    // Custom field; axios forwards config to the response/error handler.
    Object.assign(config, { _flexboardApiLogStart: start });
    return config;
  });

  client.interceptors.response.use(
    (response) => {
      const cfg = response.config;
      const start = cfg._flexboardApiLogStart;
      const ms =
        start != null && typeof performance !== 'undefined'
          ? Math.round(performance.now() - start)
          : undefined;
      const url = fullUrl(cfg);
      const method = (cfg.method || 'get').toUpperCase();
      const timing = ms != null ? ` ${ms}ms` : '';
      sendLine(
        `[FlexBoard API] ← ${response.status} ${method} ${url}${timing}`
      );
      return response;
    },
    (error) => {
      const cfg = error.config || {};
      const start = cfg._flexboardApiLogStart;
      const ms =
        start != null && typeof performance !== 'undefined'
          ? Math.round(performance.now() - start)
          : undefined;
      const status = error.response?.status;
      const label = status != null ? String(status) : 'ERR';
      let url = '(unknown)';
      try {
        url = fullUrl(cfg);
      } catch {
        // keep default
      }
      const method = (cfg.method || 'get').toUpperCase();
      const timing = ms != null ? ` ${ms}ms` : '';
      const errBody = error.response?.data;
      const errDetail =
        errBody != null
          ? ` ${typeof errBody === 'string' ? errBody : JSON.stringify(errBody)}`
          : '';
      sendLine(`[FlexBoard API] ← ${label} ${method} ${url}${timing}${errDetail}`);
      return Promise.reject(error);
    }
  );
}
